"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpolate = exports.parseBridgeMessage = exports.isTransferResponseMsg = exports.createBridgeMessage = exports.base58ToHex = exports.toUint64 = exports.toUint32 = exports.decimalToHexadecimal = void 0;
var web3_utils_1 = __importDefault(require("web3-utils"));
var jsbi_1 = __importDefault(require("jsbi"));
var bs58_1 = __importDefault(require("bs58"));
var BRIDGE_MESSAGE_DELIMITER = '#';
var removeHexLiteral = function (hex) {
    if (hex === void 0) { hex = ''; }
    return hex.replace(/^0x/, '');
};
var decimalToHexadecimal = function (d, padding) {
    var hex = Number(d).toString(16);
    padding = typeof (padding) === 'undefined' || padding === null ? padding = 2 : padding;
    while (hex.length < padding) {
        hex = "0" + hex;
    }
    return hex;
};
exports.decimalToHexadecimal = decimalToHexadecimal;
var toUint32 = function (value) {
    if (value === void 0) { value = ''; }
    var BUFFER_SIZE = 4;
    var hexValue = web3_utils_1.default.toHex(value);
    var strLength = value.length;
    var buffer = new ArrayBuffer(BUFFER_SIZE);
    var view = new DataView(buffer);
    view.setUint32(0, strLength);
    var decodedStrLength = Array.from({
        length: BUFFER_SIZE
    }).reduce(function (acc, curr, idx) { return acc + (0, exports.decimalToHexadecimal)(view.getUint8(BUFFER_SIZE - 1 - idx)); }, '');
    return "" + decodedStrLength + removeHexLiteral(hexValue);
};
exports.toUint32 = toUint32;
var toUint64 = function (value) {
    if (value === void 0) { value = ''; }
    var BUFFER_SIZE = 8;
    var buffer = new ArrayBuffer(BUFFER_SIZE);
    var vu64 = new DataView(buffer);
    var wh = jsbi_1.default.bitwiseAnd(jsbi_1.default.signedRightShift(jsbi_1.default.BigInt(value), jsbi_1.default.BigInt('32')), jsbi_1.default.BigInt('4294967295'));
    var wl = jsbi_1.default.bitwiseAnd(jsbi_1.default.BigInt(value), jsbi_1.default.BigInt('4294967295'));
    vu64.setUint32(0, jsbi_1.default.toNumber(wh), false);
    vu64.setUint32(4, jsbi_1.default.toNumber(wl), false);
    return Array.from({
        length: BUFFER_SIZE
    }).reduce(function (acc, curr, idx) {
        return acc + (0, exports.decimalToHexadecimal)(vu64.getUint8(BUFFER_SIZE - 1 - idx));
    }, '');
};
exports.toUint64 = toUint64;
var base58ToHex = function (value) {
    if (value === void 0) { value = ''; }
    var decodedValue = bs58_1.default.decode(value);
    var get32SizedArray = decodedValue.slice(1, 33);
    return removeHexLiteral(web3_utils_1.default.bytesToHex(get32SizedArray.toJSON().data));
};
exports.base58ToHex = base58ToHex;
var createBridgeMessage = function (msgType, data) {
    var messageTo;
    switch (msgType) {
        case 'AccountInfo':
            messageTo = {
                message_type: msgType,
                data: data
            };
            break;
        case 'SimpleTransfer':
            messageTo = {
                message_type: msgType,
                data: data
            };
            break;
        case 'Transaction':
            messageTo = {
                message_type: msgType,
                data: data
            };
            break;
        case 'SignRequest':
            messageTo = {
                message_type: msgType,
                data: data
            };
            break;
    }
    return messageTo ? JSON.stringify(messageTo) : null;
};
exports.createBridgeMessage = createBridgeMessage;
var isTransferResponseMsg = function (msgType) { return (msgType === 'SimpleTransferResponse' || msgType === 'SimpleTransferReponse'); };
exports.isTransferResponseMsg = isTransferResponseMsg;
var parseBridgeMessage = function (event) {
    var _a = event.data.split(BRIDGE_MESSAGE_DELIMITER), bridgeMessageType = _a[0], JSONString = _a.slice(1);
    return [bridgeMessageType, JSON.parse(JSONString.join(''))];
};
exports.parseBridgeMessage = parseBridgeMessage;
var interpolate = function (rawJson, params) {
    if (params === void 0) { params = {}; }
    var names = Object.keys(params);
    var vals = Object.values(params);
    return JSON.parse(new (Function.bind.apply(Function, __spreadArray(__spreadArray([void 0], names, false), ["return `" + JSON.stringify(rawJson) + "`;"], false)))().apply(void 0, vals));
};
exports.interpolate = interpolate;
